import {getData, postData} from "./api";
import {PaymentsUrlBuilder} from "../helpers/paymentsUrlBuilder";
import {PAYMENT_TYPE, TYPES} from "../constants";

export const init = (callback) => {
    const builder = new PaymentsUrlBuilder({
        type: TYPES.init,
    });

    getData(builder.toString(), callback);
};

export const hasResponseError = (response) => {
    if (!response) {
        console.error('Missing response');
        return false;
    } else if (response.status !== 200) {
        console.error('Invalid response: ', response);
        return true;
    } else if (response.data && JSON.stringify(response.data).includes('<html>')) {
        console.error('Something went wrong: ', response);
        return true;
    } else if (!response.data) {
        console.error('Failed to get data: ', response);
        return true;
    }
    return false;
}

export const loadSettings = (callback) => {
    const builder = new PaymentsUrlBuilder({
       type: TYPES.loadSettings,
    });

    getData(builder.toString(), callback);
};

export const createCustomerForAccount = (callback) => {
    const builder = new PaymentsUrlBuilder({
        type: TYPES.createCustomer
    });

    postData(builder.toString(), callback);
};

export const createPaymentIntent = (productId, paymentType, callback) => {
    const builder = new PaymentsUrlBuilder({
        type: TYPES.createPaymentIntent,
        productId: productId,
        paymentType: paymentType,
    });

    postData(builder.toString(), callback);
};

export const cancelPaymentIntent = (paymentIntentId, callback) => {
    const builder = new PaymentsUrlBuilder({
       type: TYPES.cancelPaymentIntent,
       paymentIntentId: paymentIntentId
    });

    postData(builder.toString(), callback);
};

export const createSetupIntent = (productId, paymentType, callback) => {
  const builder = new PaymentsUrlBuilder({
      type: TYPES.createSetupIntent,
      productId: productId,
      paymentType: paymentType,
  });

    postData(builder.toString(), callback);
};

export const cancelSetupIntent = (setupIntentId, callback) => {
    const builder = new PaymentsUrlBuilder({
       type: TYPES.cancelSetupIntent,
        setupIntentId: setupIntentId
    });

    postData(builder.toString(), callback);
};

export const saveAcPaymentData = (paymentId, doNotRenew, callback) => {
    savePaymentData(PAYMENT_TYPE.AC, paymentId, null, doNotRenew, callback);
};

export const saveVriPaymentData = (paymentId, planValue, doNotRenew, callback) => {
    savePaymentData(PAYMENT_TYPE.VRI, paymentId, planValue, doNotRenew, callback);
};

export const saveVdsPaymentData = (paymentId, planValue, doNotRenew, callback) => {
    savePaymentData(PAYMENT_TYPE.VDS, paymentId, planValue, doNotRenew, callback);
};

const savePaymentData = (paymentType, paymentId, planValue, doNotRenew, callback) => {
    const queryParms = {
        type: TYPES.savePaymentData,
        paymentId: paymentId,
        paymentType: paymentType,
    };

    if (planValue) {
        queryParms.planValue = planValue;
    }

    if (doNotRenew) {
        queryParms.doNotRenew = doNotRenew;
    }

    const builder = new PaymentsUrlBuilder(queryParms);
    postData(builder.toString(), callback);
};


export const chargeAcPayment = (paymentId, paymentMethodId, planValue, doNotRenew, callback) => {
    chargePayment(PAYMENT_TYPE.AC, paymentId, paymentMethodId, planValue, doNotRenew, callback);
};

export const chargeVriPayment = (paymentId, paymentMethodId, planValue, doNotRenew, callback) => {
    chargePayment(PAYMENT_TYPE.VRI, paymentId, paymentMethodId, planValue, doNotRenew, callback);
};

export const chargeVdsPayment = (paymentId, paymentMethodId, planValue, doNotRenew, callback) => {
    chargePayment(PAYMENT_TYPE.VDS, paymentId, paymentMethodId, planValue, doNotRenew, callback);
};

const chargePayment = (paymentType, paymentId, paymentMethodId, planValue, doNotRenew, callback) => {
    const queryParms = {
        type: TYPES.chargePayment,
        paymentId: paymentId,
        paymentType: paymentType,
        paymentMethodId: paymentMethodId,
    };

    if (planValue) {
        queryParms.planValue = planValue;
    }

    if (doNotRenew) {
        queryParms.doNotRenew = doNotRenew;
    }

    const builder = new PaymentsUrlBuilder(queryParms);
    postData(builder.toString(), callback);
};

export const removePaymentMethods = (paymentMethodId, callback) => {
    const builder = new PaymentsUrlBuilder({
        type: TYPES.removePaymentMethods,
        paymentMethodId: paymentMethodId
    });

    postData(builder.toString(), callback);
};

export const setAsDefaultPaymentMethod = (paymentMethodId, callback) => {
    const builder = new PaymentsUrlBuilder({
        type: TYPES.setAsDefaultPaymentMethod,
        paymentMethodId: paymentMethodId
    });

    postData(builder.toString(), callback);
};

export const setACDoNotRenew = (doNotRenew, callback) => {
    setDoNotRenew(PAYMENT_TYPE.AC, doNotRenew, callback);
};

export const setVRIDoNotRenew = (doNotRenew, callback) => {
    setDoNotRenew(PAYMENT_TYPE.VRI, doNotRenew, callback);
};

export const setVDSDoNotRenew = (doNotRenew, callback) => {
    setDoNotRenew(PAYMENT_TYPE.VDS, doNotRenew, callback);
};

const setDoNotRenew = (paymentType, doNotRenew, callback) => {
    const builder = new PaymentsUrlBuilder({
        type: TYPES.setDoNotRenew,
        paymentType: paymentType,
        doNotRenew: doNotRenew
    });

    postData(builder.toString(), callback);
};

export const updateACPlan = (updateAction, planValue, callback) => {
    updatePaymentSettings(PAYMENT_TYPE.AC, updateAction, planValue, callback);
};

export const updateVRISubscription = (updateAction, planValue, callback) => {
    updatePaymentSettings(PAYMENT_TYPE.VRI, updateAction, planValue, callback);
};

export const updateVDSSubscription = (updateAction, planValue, callback) => {
    updatePaymentSettings(PAYMENT_TYPE.VDS, updateAction, planValue, callback);
};

const updatePaymentSettings = (paymentType, updateAction, planValue, callback) => {
    const queryParms = {
        type: TYPES.updatePaymentSettings,
        paymentType: paymentType,
        updateAction: updateAction,
    };

    if (planValue) {
        queryParms.planValue = planValue;
    }

    const builder = new PaymentsUrlBuilder(queryParms);
    postData(builder.toString(), callback);
};

export const startVRIFreeTrial = (subscriptionLevel, paymentMethodId, callback) => {
    startFreeTrial(PAYMENT_TYPE.VRI, subscriptionLevel, paymentMethodId, callback);
};

export const startVDSFreeTrial = (subscriptionLevel, paymentMethodId, callback) => {
    startFreeTrial(PAYMENT_TYPE.VDS, subscriptionLevel, paymentMethodId, callback);
};

export const startFreeTrial = (paymentType, subscriptionLevel, paymentMethodId, callback) => {
    const builder = new PaymentsUrlBuilder({
        type: TYPES.startFreeTrial,
        paymentType: paymentType,
        subscriptionLevel: subscriptionLevel,
        paymentMethodId: paymentMethodId
    });

    postData(builder.toString(), callback);
};

export const setPreferredMethod = (paymentType, paymentMethodId, callback) => {
    if (paymentType != null) {
        const builder = new PaymentsUrlBuilder({
            type: TYPES.setPreferredMethod,
            paymentType: paymentType,
            paymentMethodId: paymentMethodId
        });
        postData(builder.toString(), callback);
    } else {
        const builder = new PaymentsUrlBuilder({
            type: TYPES.setPreferredMethod,
            paymentMethodId: paymentMethodId
        });
        postData(builder.toString(), callback);
    }
};